import React, { Component } from "react";
import { goBack } from "react-router-redux";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm } from "redux-form";
import Input from "../../../../components/form/Input";
import Button from "../../../../components/form/Button";
import CroField from "../../components/generalForm/CroField";
import { styles } from "../../index";
import { changePassword } from "../../CroActions";
import { breadcrumbs, togglePanel } from "../../../../actions/appActions";

class ChangePassForm extends Component {
  componentWillMount() {
    this.props.breadcrumbs(this.props.breadcrumbsItems);
  }

  render() {
    const {
      router: { goBack },
      error,
      handleSubmit,
      submitting,
    } = this.props;
    return (
      <div className="publicPage">
        <div className="publicPage__card publicPage__card--narrow">
          <div className="publicPage__header">
            <div className="publicPage__title">Změna hesla</div>
            <div className="publicPage__subtitle">
              Zadejte původní heslo a nastavte nové.
            </div>
          </div>

          <form onSubmit={handleSubmit} className="publicPage__form">
            <div className="publicPage__fields">
              <CroField
                title="Původní heslo"
                type="password"
                name="old"
                component={Input}
              />
              <CroField
                title="Nové heslo"
                type="password"
                name="new"
                component={Input}
              />
              <CroField
                title="Nové heslo znovu"
                type="password"
                name="newAgain"
                component={Input}
              />
            </div>

            {error && <div className="error">{error}</div>}

            <div className="publicPage__actions">
              <Button
                type="submit"
                style={styles.buttons}
                label="Odeslat"
                disabled={submitting}
              />
              <Button
                type="button"
                style={styles.buttons}
                label="Zpět"
                disabled={submitting}
                onClick={goBack}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const Form = reduxForm({
  form: "changePassForm",
  validate: (values) => {
    const errors = {};
    if (!values.old) {
      errors.old = "Povinné";
    }
    if (!values.new) {
      errors.new = "Povinné";
    }
    if (!values.newAgain) {
      errors.newAgain = "Povinné";
    }
    if (values.new && values.newAgain && values.new !== values.newAgain) {
      errors.new = "Musí se shodovat";
      errors.newAgain = "Musí se shodovat";
    }
    return errors;
  },
})(ChangePassForm);

const mapStateToProps = () => ({
  breadcrumbsItems: [{ label: "Změna hesla" }],
});

const onSubmit = (url, data) => async (dispatch) => {
  await changePassword(data, dispatch, url);
  dispatch(togglePanel("Heslo úspěšně změněno"));
  dispatch(goBack());
};

const mapDispatchToProps = (dispatch, { auth }) => ({
  ...bindActionCreators({ breadcrumbs }, dispatch),
  onSubmit: (data) =>
    onSubmit(`${auth.startUrl}/api/profil/zmena-hesla`, data)(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
